module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reservation-list row column"
  }, [_c('reservation-list-form', {
    on: {
      "filterReservations": _vm.setSearch,
      "searchReservations": _vm.setSearch
    }
  }), _c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "search": _vm.search,
      "searchRangeDataLoader": _vm.getReports
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08c56a0d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ReservationList.vue
// module id = 2242
// module chunks = 1